module.exports = __webpack_public_path__ + "img/8.943aa9f7.jpg";